import React from "react";
import { Button, Form, Input, notification, Typography } from "antd";
import styled from 'styled-components';
import { CHANGE_PASSWORD } from "../../Apollo/graphql/Mutation/ChangePasswordMutation";
import { useMutation } from "@apollo/client";
import { useHistory } from "react-router-dom";
const ForgetPasswordContainer = styled.div`
  display: flex;
  flex: 1;
  height: 100vh;
  justify-content: center;
  align-items: center;
`
const InsideContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid gray;
  padding: 1rem;
  /* margin: 0 auto; */
  height: 450px;
  width: 400px;
  box-shadow: 0 5px 5px rgba(72, 65, 65, 0.75);
`

const ForgotPasswordScreen = () => {
  const history = useHistory();
  const url = window.location.href;
  const token = url.split('?')[1].split('=')[1];

  const [changePasswordMutation] = useMutation(CHANGE_PASSWORD);

  const onFinish = async (values: any) => {
    if (values.password !== values.confirmPassword) {
      notification.error({
        message: "Error",
        description: "Password doesnt match!"
      })
    } else {
      try {
        const res = await changePasswordMutation({
          variables: {
            token: token,
            password: values.password
          }
        })
        if (res.data.changePassword === true) {
          // history.push('/signin');
          notification.success({
            message: 'Success',
            description: "Successfully change your password"
          })
          history.push('/signin')
        }
      } catch (err) {
        console.log("error",err)
      }
    }
  };
  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  return <ForgetPasswordContainer>
    <InsideContainer>

      <Typography.Title level={3} style={{ textAlign: 'center' }}>Change Password</Typography.Title>
      <Form
        name="basic"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        style={{
          display: 'flex',
          flexDirection: 'column',
          margin: 'auto'
        }}
      >
        <Form.Item
          label="New Password"
          name="password"
          rules={[{ required: true, message: 'Please input your new password!' }]}
        >
          <Input.Password size="large" />
        </Form.Item>
        <Form.Item
          label="Confirm Password"
          name="confirmPassword"
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <Input.Password size="large" />
        </Form.Item>
        <Form.Item >
          <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
            Done
          </Button>
        </Form.Item>
      </Form>
    </InsideContainer>
  </ForgetPasswordContainer>
};

export default ForgotPasswordScreen;
